<template>
  <div>
    <div v-if="getAchievementFeed">
      <div class="h3 text-start fw-bold mb-3">Latest Activity</div>
      <div v-for="(item, index) in paginatedFeed" :key="item" class="mb-3">
        <div class="text-start fs-5">[{{ index + 1 }}]</div>
        <div v-if="item.achievement">
          <UserCard v-bind="item">
            <AchievementBadge :achievement="item.achievement"
          /></UserCard>
        </div>
        <div v-else>
          <GroupFeedCard v-bind="item" />
        </div>
      </div>
      <div class="mt-4">
        <button
          class="btn btn-dark fs-5 me-3"
          :disabled="currentPage === 1"
          @click="previousPage()"
        >
          <i class="bi bi-arrow-left"></i>
        </button>
        <span class="fw-bold">Page {{ currentPage }} of {{ totalPages }}</span>
        <button
          class="btn btn-dark fs-5 ms-3"
          :disabled="currentPage === totalPages"
          @click="nextPage()"
        >
          <i class="bi bi-arrow-right"></i>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

import AchievementBadge from "@/components/activity/AchievementBadge.vue";
import UserCard from "@/components/activity/UserCard.vue";
import GroupFeedCard from "@/components/activity/GroupFeedCard.vue";

export default {
  name: "AchievementFeed",
  components: { AchievementBadge, UserCard, GroupFeedCard },
  data() {
    return {
      currentPage: 1, // Current page number
      pageSize: 10 // Number of items per page
    };
  },
  props: {},
  computed: {
    ...mapGetters("achievements", ["getAchievementFeed"]),
    // Calculate total pages based on feed length and page size
    totalPages() {
      return Math.ceil(this.getAchievementFeed.length / this.pageSize);
    },
    // Get the feed items for the current page
    paginatedFeed() {
      const start = (this.currentPage - 1) * this.pageSize;
      const end = start + this.pageSize;
      return this.getAchievementFeed.slice(start, end);
    }
  },
  methods: {
    // Navigate to the next page
    nextPage() {
      if (this.currentPage < this.totalPages) {
        this.currentPage++;
      }
    },
    // Navigate to the previous page
    previousPage() {
      if (this.currentPage > 1) {
        this.currentPage--;
      }
    }
  }
};
</script>
